module.exports = __webpack_public_path__ + "img/start-building-designer.247e7a3e.png";